// INFO: The io framework is beeing imported globally (TOOD: Replace io framework)
// import io from './plugins/io.js'
// import address from './components/address.js'
// import spamEmailProtection from './components/email-spam-protection.js'
import themeFunctions from './components/theme-functions.js'
import navdefault from './components/nav-default.js'
import navmain from './components/nav-main.js'
import header_sticky from './components/header-sticky.js'

export default {
    // io,
    themeFunctions,
    // address,
    navdefault,
    navmain,
    // spamEmailProtection
    header_sticky
}
